<template>
  <div class="competitionPractice_wrap">
    <div>
      <span>token：</span>
      <el-input v-model="value"></el-input>
      <el-button @click="jump">跳转</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      value: 'b37b09b4-fed0-489c-bf85-bba05116161c',
    }
  },
  methods: {
    jump(){
      let token = this.value
      window.open('https://scpuat.cailian.net/#/planHome?pattern_lx=0&token='+token)
    }
  }
}
</script>
<style lang="scss" scoped>
  .competitionPractice_wrap{
    height: calc(100% - 32px);
    margin: 16px;
    padding: 0 16px;
    background: #fff;
    overflow-y: auto;
    div{
      display: flex;
      height: 80px;
      align-items: center;
      padding-left: 10px;
      /deep/ .el-input{
        width: 350px;
      }
      button{
        margin-left: 20px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/homepage/competitionPractice.vue